export const compareValues=(first,second)=>null!==first&&null!==second&&first.id===second.id;